





import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class JdhLogicalCheckbox extends Vue {
    @Prop() value!: boolean

}
